import React from "react";
import { useOutletContext } from "react-router-dom";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import useLanguages from "src/hooks/useLanguages";
import useModes from "src/hooks/useModes";

const TimingOption = [
  {
    label: "Morning",
    value: "Morning",
  },
  {
    label: "Noon",
    value: "Noon",
  },
  {
    label: "Evening ",
    value: "Evening",
  },
  {
    label: "Any ",
    value: "Any",
  },
];

const Preference = () => {
  const [{ formikProps }]: any = useOutletContext();

  const { modes, isDataLoading: isChapterLoading } = useModes();
  const { languages, isDataLoading: isLanguageLoading } = useLanguages();

  const LanguageOption = languages?.map((el: any) => {
    return {
      label: el?.languageName,
      value: el?._id,
    };
  });
  const ModesOption = modes?.map((el: any) => {
    return {
      label: el?.modeName,
      value: el?._id,
    };
  });

  const { values, setFieldValue, handleBlur, isSubmitting } = formikProps;

  return (
    <div >
      <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 xl:gap-6 gap-4">
        {/* Language */}
        <div>
          <ATMMultiSelect
            name="language"
            value={values?.language}
            onChange={(newValue) => setFieldValue("language", newValue)}
            onBlur={handleBlur}
            label="Language"
            placeholder="Select Language"
            options={LanguageOption}
            isLoading={isLanguageLoading}
          />
        </div>
        {/* Mode Type */}
        <div>
          <ATMMultiSelect
            name="mode_type"
            value={values?.mode_type}
            onChange={(newValue) => setFieldValue("mode_type", newValue)}
            onBlur={handleBlur}
            label="Mode Type"
            placeholder="Select Mode Type"
            isLoading={isChapterLoading}
            options={ModesOption}
          />
        </div>
        {/* timing */}
        <div>
          <ATMMultiSelect
            name="timing"
            value={values?.timing}
            onChange={(newValue) => setFieldValue("timing", newValue)}
            onBlur={handleBlur}
            label="Timing"
            placeholder="Select Timing"
            options={TimingOption}
          />
        </div>
      </div>

      <div className="flex justify-end mt-5">
        <ATMLoadingButton
          className="flex justify-end w-[70px] px-5"
          isLoading={isSubmitting}
          type="submit"
        >
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default Preference;
